import api from './api'

export default {
  async getAll() {
    const { data } = await api.get('/leaves')
    return data
  },
  async getById(id) {
    const { data } = await api.get(`/leaves/${id}`)
    return data
  },
  async create(leaveRequest) {
    const { data } = await api.post('/leaves', leaveRequest)
    return data
  },
  async updateStatus(id, status) {
    const { data } = await api.patch(`/leaves/${id}/status`, { status })
    return data
  },
  async getByEmployee(employeeId) {
    const { data } = await api.get('/leaves', { params: { employeeId } })
    return data
  }
} 